<template>
  <v-dialog
    v-model="dialog"
    width="420px">
    <div class="dialog-container">
      <div class="dialog-header flex-sb-center">
        <span>New Renew Ticket</span>
        <i
          class="el-icon-close"
          @click="handleCancel"></i>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div
            v-if="is_fina"
            class="form-item">
            <el-form-item
              ref="merchant_platform"
              :rules="rules.select"
              prop="merchant_platform">
              <select-quote-type
                v-model.number="formData.merchant_platform"
                disable
                is-fina></select-quote-type>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Assignee</span>
            <el-form-item
              ref="assignee_id"
              prop="assignee_id"
            >
              <v-select
                v-model="formData.assignee_id"
                icon="user-nurse"
                :list="assigneeList"
                :clearable="true"
              />
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span>Customer</span>
            <el-form-item
            >
              <v-input
                :value="form.customer_id<=0?form.isrd_nm:customer.isrd_nm"
                disabled
                type="text"/>
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span>Policy</span>
            <el-form-item
              ref="pcy_id"
              prop="pcy_id"
            >
              <v-input
                v-model="formData.pcy_id"
                :disabled="true"
                labelKey="pcy_id"
                valueKey="pcy_id"
                :list="customerPolicyList"/>
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span>Contact Number</span>
            <el-form-item
              ref="contact_no"
              prop="contact_no"
              :rules="rules.mobile_no"
            >
              <v-input
                v-model="formData.contact_no"
                :uppercase="true"
                maxlength="8"
                type="text"/>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <v-button
          gray
          @click="handleCancel">Cancel</v-button>
        <v-button
          green
          @click="onContinue">Continue</v-button>
      </div>
    </div>

  </v-dialog>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {getCustomerPolicy} from '@api/ticket'
import {createRenewalTicket} from '@api/renewal'
import SelectQuoteType from '@/views/components/select-quote-type'
export default {
  name: 'new-renew-ticket-dialog',
  components:{
    SelectQuoteType
  },
  mixins: [MixinOptions,MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: Object,
      default: () => ({})
    },
    value:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      customerPolicyList:[],
      formData: {
        assignee_id:'',
        customer_id: '',
        pcy_id: '',
        contact_no: '',
        merchant_platform:1
      },
    }
  },
  computed:{
    cs_id(){
      let cs_id = localStorage.getItem('cs_id')
      return cs_id||''
    },
    is_fina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform==2
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val
        if(val) {
          this.formData.assignee_id = this.cs_id
          this.handlerChangeCustomer(this.formData.customer_id)
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        Object.keys(this.formData).some(key=>{
          if(val[key]){
            this.formData[key] = val[key]||this.formData[key]
          }
        })
      }
    },
  },
  methods: {
    handlerChangeCustomer(id) {
      if(id) {
        this.network().getCustomerPolicy(id)
      }
    },
    handleCancel() {
      this.$emit('input',false)
    },
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.network().createRenewalTicket()
        }
        else {
          console.log(rules)
        }
      })
    },
    network() {
      return {
        getCustomerPolicy: async id => {
          const { data } = await getCustomerPolicy({
            customer_id: id
          })
          this.customerPolicyList = data.policy
        },
        createRenewalTicket: async(params={})=> {
          let {id} = this.$route.query||{}
          let {contact_no,assignee_id,merchant_platform} = this.formData||{}
          let params_data ={}
          // if(this.is_fina)
          params_data.merchant_platform = 1
          const { data } = await createRenewalTicket({
            cs_id:assignee_id,
            contact_phone:contact_no,
            pre_order_id:id,
            ...params_data
          })
          this.$router.push({
            path:'/tickets/detail',
            query:{
              ticket_id:data.id
            }
          })
          this.$emit('input',false)
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
  font-family: 'inter';
}
.dialog-container {
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      /*margin: 10px 0px;*/
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .width-80{
      width: 80px;
    }
    .type-button {
      // margin-right: 20px;
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 20px;
      /deep/ .el-radio-group{
        display: flex;
      }
      ::v-deep .el-radio {
        //margin-right: 23px;
        margin-top: 8px;
        width: 50%;
        .el-radio__label {
          display: inline-block;

          padding: 0px 10px;
          height: auto;
          //line-height: 30px;
          font-size: 12px;
          border-radius: 50px;
          border: 1px solid #E1E4E8;
          color: #24292E;
          background: white;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
          margin-left:8px ;
          margin-right: 23px;
        }
      }
    }
    /deep/ .el-date-editor{
      width: 100% !important;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;

  }
  .form-item{
    .select-type{
      display: flex;
      justify-content: space-between;
      /deep/.select-pay{
        //margin-right: 30px;
        width: calc(50% - 10px);
        .icon-block{
          margin-right: 10px;
          margin-left: 0px;
        }
      }
    }
  }
}
</style>
